import { Constants } from '@leverege/molten-core';
import Molten from "./Molten.js";
import Inspector from "./inspector/Inspector.js";
import MoltenCli from "./cli/index.js";
if (window.leveregeMolten) {
  // eslint-disable-next-line no-console
  console.error('Multiple version of molten detected');
} else {
  window.leveregeMolten = {
    molten: new Molten()
  };
  window.MoltenCli = MoltenCli;
  window.Molten = window.leveregeMolten.molten;
  if (process.env.NODE_ENV === 'development') {
    window.moltenInspector = new Inspector({
      molten: window.leveregeMolten.molten
    });
  }
}
export default window.leveregeMolten.molten;
export { Constants };